import React, { useEffect, useState } from "react";
import "./StickyTop.scss";
const BackToTopSticky = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
    <div className="top-sticky-section">
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="back-to-top-cta"
        >
          Top
        </button>
      )}</div>
    </>
  );
};

export default BackToTopSticky;
